import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Tag, Timestamp, } from '@dixa/lib-shared-habla';
import { conversationStatusAttributes, } from 'lib-shared-legacy-types';
import { Link } from 'react-router-dom';
import { getChannelName } from 'app/utils/channelName';
import styles from './styles.module.scss';
export function makeColumns(userSelector, userLabel) {
    return [
        {
            label: '#',
            selector: function renderCsid({ conversation }) {
                return (_jsxs(Link, Object.assign({ to: `/conversation/${conversation.id}` }, { children: ["#", conversation.id] })));
            },
            style: { width: 1 },
        },
        {
            label: userLabel,
            selector: function renderUser(userConversation) {
                var _a;
                return (_jsxs("div", Object.assign({ className: styles.user }, { children: [_jsx(Avatar, { user: userSelector(userConversation) }), _jsx("div", Object.assign({ className: styles.userName }, { children: (_a = userSelector(userConversation)) === null || _a === void 0 ? void 0 : _a.name }))] })));
            },
            style: { width: '30%' },
        },
        {
            label: 'Status',
            selector: function renderStatus({ conversation }) {
                if (!conversation.status) {
                    return null;
                }
                const status = conversationStatusAttributes.get(conversation.status);
                return _jsx(Tag, Object.assign({ color: status === null || status === void 0 ? void 0 : status.color }, { children: status === null || status === void 0 ? void 0 : status.prettyName }));
            },
        },
        {
            label: 'Channel',
            selector: ({ conversation }) => conversation.initial_channel &&
                getChannelName(conversation.initial_channel),
        },
        {
            label: 'Direction',
            selector: function renderDirection({ conversation }) {
                return _jsx("div", Object.assign({ className: styles.direction }, { children: conversation.direction }));
            },
        },
        {
            label: 'Last update',
            selector: function renderLastUpdate({ conversation }) {
                return (conversation.last_message_created_at && (_jsx(Timestamp, { relative: true, time: conversation.last_message_created_at })));
            },
        },
    ];
}
